import { defineMessages } from 'react-intl';

type MessageKeys = 'rateLimitWarning' | 'rateLimitWarningDescription';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		rateLimitWarning: {
			id: 'chat-history.rate-limit-warning',
			description:
				'Warning message text displayed in a rate limit warning within the AI conversation interface, indicating how long the user must wait before sending another message. Shown as text in a warning notification or message. The secondsRemaining placeholder will be substituted with the number of seconds remaining. The ICU MessageFormat plural statement resolves to "# second" when count is 1, or "# seconds" when count is 2 or more. The purpose is to inform users exactly how long they need to wait before they can send another message.',
			defaultMessage: 'Please wait {secondsRemaining, plural, one {# second} other {# seconds}}',
		},
		rateLimitWarningDescription: {
			id: 'chat-history.rate-limit-warning-description',
			description:
				'Description text displayed in a rate limit warning within the AI conversation interface, explaining why the rate limit was triggered. Shown as the description text below the warning message. The purpose is to inform users that they are sending messages too quickly and need to slow down to avoid overwhelming the system.',
			defaultMessage: 'Messages are being sent too fast, please wait.',
		},
	});

export default message;
